
import '../STYLES/Loading.css'
export function Loading() {
    return <div className="loading vertical-center">
        <div className="horizontal-center">
            <p className='loading-text'>one moment please...</p>
        </div>
    </div>
}